import { combineReducers } from "redux";

import { IAsyncData } from "../../../../core/models";
import {
  asyncItemReducerGenerator,
  generateCrudActionTypes,
  generateCrudReducers,
  generateCrudReduxActionCreators,
  IAsyncReduxAction,
  ICRUDActionTypes,
  ICrudReduxActionCreators,
  ICRUDReduxState,
} from "../../../../core/redux";
import { IProductHistory } from "../../data/entities";
import { ProductHistoryRepoImpl } from "../../data/repo";

const moduleName = "ProductHistory";

interface IProductHistoryActionTypes extends ICRUDActionTypes {
  getHistoryList: string;
}

const actionTypes: IProductHistoryActionTypes = {
  ...generateCrudActionTypes(moduleName),
  getHistoryList: `GET_${moduleName}_LAST_LIST`,
};

interface IProductHistoryActionCreators extends ICrudReduxActionCreators<IProductHistory, {}> {
  getHistoryList: (searchQuery?: string) => IAsyncReduxAction<IProductHistory[]>;
}

export const productHistoryReduxActions: IProductHistoryActionCreators = {
  ...generateCrudReduxActionCreators<IProductHistory, {}>({
    actionTypes,
    repository: ProductHistoryRepoImpl,
  }),
  getHistoryList: (searchQuery) => ({
    type: actionTypes.getHistoryList,
    payload: ProductHistoryRepoImpl.getHistoryList(searchQuery),
  }),
};

export interface IProductHistoryReduxState extends ICRUDReduxState<IProductHistory> {
  historyList: IAsyncData<IProductHistory[]>;
}

export const ProductHistoryReducers = combineReducers<IProductHistoryReduxState>({
  ...generateCrudReducers<IProductHistory>(actionTypes),
  historyList: asyncItemReducerGenerator<IProductHistory[]>(actionTypes.getHistoryList),
});
